import React from 'react'
import styled from 'styled-components/macro'

import { QShopHeaderIntroIntro } from '../../graph/generated'

interface IProps {
  intro?: Maybe<QShopHeaderIntroIntro>
}

const ShopIntroStyled = styled.div`
  margin: 0.8rem 1rem 1rem 1.3rem;
`

export const ShopIntro: React.FC<IProps> = ({ intro }) => (
  <ShopIntroStyled data-testid="headerText">
    {intro ? intro.headerText : ''}
  </ShopIntroStyled>
)
